/**
 * src/api/sla.js
 * Panel de SLA por cliente (semáforo de sistema por tenant).
 */
import api from './client'

export const getSlaResumen = () =>
  api.get('/admin/sla/resumen').then(r => r.data)

export const getSlaInforme = (mes) =>
  api.get('/admin/sla/informe', { params: mes ? { mes } : {} }).then(r => r.data)
